export default function (totalCharge, quantity, transactionId) {
  fbq("track", "Purchase", {
    value: totalCharge,
    currency: "USD",
    order_id: transactionId,
    content_ids: transactionId,
    content_type: "product",
  });
}
